import { ReactNode, createContext, useContext, useState } from "react";
import DeleteModal from "./DeleteModal";
import { IAppVersion } from "models/appVersion";

interface IAlertProps {
  showDelete: (driver: IAppVersion) => void;
}

export const AppVersionAlertContext = createContext<IAlertProps>(
  {} as IAlertProps
);

export const useAppVersionAlertContext = () =>
  useContext<IAlertProps>(AppVersionAlertContext);

interface IOpen {
  open: boolean;
  appVersion: IAppVersion | null;
}

export function AppVersionAlertContextProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [openDelete, setOpenDelete] = useState<IOpen>({
    open: false,
    appVersion: null,
  });

  const showDelete = (appVersion: IAppVersion) =>
    setOpenDelete({ open: true, appVersion });
  const handleCloseDelete = () =>
    setOpenDelete({ open: false, appVersion: null });

  return (
    <AppVersionAlertContext.Provider value={{ showDelete }}>
      {openDelete.appVersion && (
        <DeleteModal
          open={openDelete.open}
          appVersion={openDelete.appVersion}
          handleClose={handleCloseDelete}
        />
      )}
      {children}
    </AppVersionAlertContext.Provider>
  );
}
